module.exports = __webpack_public_path__ + "static/media/rewardbg.e4cc39b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/rewardbg.png
// module id = 1170
// module chunks = 0